import React from 'react';
import Navbar from './components/Navbar/Navbar';
import SummaryCards from './components/SummaryCards/SummaryCards';
import LiveUserStatus from './components/LiveUserStatus/LiveUserStatus';
import BarGraphs from './components/BarGraphs/BarGraphs';
import AuditHistory from './components/AuditHistory/AuditHistory';
import UserActivity from './components/UserActivity/UserActivity';
import PerformanceMetrics from './components/PerformanceMetrics/PerformanceMetrics';
import { Box, Stack } from '@mui/material';

const DashboardWithNavbar = () => {
  return (
    <Box sx={{ bgcolor: 'background.default', color: 'text.primary', minHeight: '100%' }}>
      <Navbar />
      <Box sx={{ p: 3 }}>
        <Stack spacing={3}>
          <SummaryCards />
          <LiveUserStatus />
          <Stack direction={{ xs: 'column', md: 'row' }} spacing={3}>
            <Box sx={{ flex: 3 }}>
              <BarGraphs />
            </Box>
            <Box sx={{ flex: 1 }}>
              <PerformanceMetrics />
            </Box>
          </Stack>
          <Stack direction={{ xs: 'column', md: 'row' }} spacing={3}>
            <Box sx={{ flex: 6 }}>
              <AuditHistory />
            </Box>
            <Box sx={{ flex: 3 }}>
              <UserActivity />
            </Box>
          </Stack>
          <Box sx={{ mt: 3 }}>
            {/* Lead credit table moved to Tools menu */}
          </Box>
        </Stack>
      </Box>
    </Box>
  );
};

export default DashboardWithNavbar;
